import { BaseSerializer } from './base.serializer'
import { Exam } from 'models/exams/exam.model'
import { ExamSectionSerializer } from './exams/exam-section.serializer'
import { ExamSectionsGradeSerializer } from './exam-sections-grade.serializer';
import { ExamQuestionsGradeSerializer } from './exam-questions-grade.serializer';

export class ExamSerializer extends BaseSerializer<Exam> {
  static SERIALIZABLE_ATTRIBUTES = ['comment', 'name', 'folderId', 'sections', 'timeLimit', 'sectionsGrades', 'questionsGrades', 'onlySectionsGrade', 'onlyQuestionsGrade']
  static SERIALIZERS = {
    sections: ExamSectionSerializer,
    sectionsGrades: ExamSectionsGradeSerializer,
    questionsGrades: ExamQuestionsGradeSerializer
  }
  static SERIALIZE_RENAME_KEYS = {
    sections: 'examSectionsAttributes',
    sectionsGrades: 'sectionsGradesAttributes',
    questionsGrades: 'questionsGradesAttributes'
  }

  static DESERIALIZERS = {
    sections: ExamSectionSerializer,
    sectionsGrades: ExamSectionsGradeSerializer,
    questionsGrades: ExamQuestionsGradeSerializer
  }
  static DESERIALIZE_RENAME_KEYS = {
    examSections: 'sections',
    "exam_sections": 'sections'
  }

  static initializeObject(attributes: Object): Exam {
    return new Exam(attributes)
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/serializers/exam.serializer.ts